const API_STACK = 'billing/';

export const PATCH_SUBSCRIPTION_TIER = API_STACK + 'subscription/:providerUuid';
export const GET_OFFER = API_STACK + 'offer/:offerCode';
export const POST_CREATE_SUBSCRIPTION_OPERATION = API_STACK + 'operations/subscription/';